var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.classes,
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.purchaseOutfit.apply(null, arguments)
        }
      }
    },
    [
      _vm._v(
        "\n    " +
          _vm._s(_vm.isOutfitInCart ? "Added to Cart" : "Purchase Outfit") +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6ea0bc8", { render: render, staticRenderFns: staticRenderFns })
  }
}